import { PricesResponseV2 } from "@ssc-booking/api-contracts"
import * as E from "fp-ts/Either"
import { noAvailabilityForOccupancy, priceResponse } from "../../../test-support/common"
import { cruiseCode } from "./cruisecode"

export const classicVerandaPricesV2 = priceResponse(cruiseCode, "CV", { depositPercentage: 25, totalAmount: 11600 })

const prices = [
    E.right(classicVerandaPricesV2),
    // E.right(priceResponse(cruiseCode, "DX", { depositPercentage: 25, totalAmount: 12600 })),
    E.right(priceResponse(cruiseCode, "G1", { depositPercentage: 25, totalAmount: 24000 })),
    E.right(priceResponse(cruiseCode, "G2", { depositPercentage: 25, totalAmount: 30600 })),
    E.left(noAvailabilityForOccupancy(cruiseCode, "O1")),
    E.left(noAvailabilityForOccupancy(cruiseCode, "O2")),
    E.right(priceResponse(cruiseCode, "R1", { depositPercentage: 25, totalAmount: 23200 })),
    E.right(priceResponse(cruiseCode, "R2", { depositPercentage: 25, totalAmount: 30000 })),
    E.right(priceResponse(cruiseCode, "ME", { depositPercentage: 25, totalAmount: 26000 })),
    // E.right(priceResponse(cruiseCode, "SL", { depositPercentage: 25, totalAmount: 19000 })),
    E.left(noAvailabilityForOccupancy(cruiseCode, "VI")),
    E.right(
        priceResponse(cruiseCode, "SV", {
            depositPercentage: 15,
            totalAmount: 10600,
            availability: "guaranteed",
        }),
    ),
    E.right(
        priceResponse(cruiseCode, "DX", {
            depositPercentage: 15,
            totalAmount: 12600,
            availability: "guaranteed",
        }),
    ),
    E.right(
        priceResponse(cruiseCode, "SL", {
            depositPercentage: 25,
            totalAmount: 12200,
            availability: "partial",
        }),
    ),
]

export default PricesResponseV2.build({ prices: prices })
